export const PUBLIC_CHAT_NAME = 'Лента';
